export default {
  edit: 'Redaktoni',
  delete: 'Dshije',
  detail: 'detaj',
  deleteThisImage: 'Fshije këtë imazh',
};
